import RootLayout from "../../components/layout/RootLayout";
import GetStarted from "./GetStarted";
import Hero from "./Hero";
import Industries from "./Industries";
import Why from "./Why";

const SLM = () => {
  return (
    <RootLayout>
      <main>
        <Hero />
        <Why />
        <Industries />
        <GetStarted />
      </main>
    </RootLayout>
  );
};

export default SLM;
